import PrivateLayout from 'layouts/PrivateLayout';
import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import RedirectionPath from 'widgets/RedirectionPath';
import LoginPage from './auth/screens/LoginPage';
import ChannelCreatePage from './channel/screens/Create';
import ChannelManangementPage from './channel/screens/Dashboard';
import ChannelDetailPage from './channel/screens/Detail';
import ScreenManagementPage from './dashboard/screens/Dashboard';
import ScreenDetailPage from './dashboard/screens/Detail';
// import MediaDashboardLayout from './media/screens/Dashboard';
import MediaLibraryListPage from './media/screens/Dashboard/LibraryList';
// import MediaLinkListPage from './media/screens/Dashboard/LinkList';
import NotFoundPage from './NotFound';
import StoryboardPage from './storyboard';
import SidebarLayout from 'layouts/SidebarLayout';
import StoreManagementPage from './store/screens/Dashboard';
import StoreDetailPage from './store/screens/Detail';
import MediaFolderDetailPage from './media/screens/FolderDetail';
import PlaylistManagementPage from './playlist/screens/Dashboard';
import PlaylistCreatePage from './playlist/screens/Create';
import PlaylistDetailPage from './playlist/screens/Detail';

const RootScreens = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route element={<PrivateLayout />}>
          <Route element={<SidebarLayout />}>
            <Route index path='' element={<RedirectionPath path='/screen' />} />
            <Route path='screen' element={<ScreenManagementPage />} />
            <Route path='channel' element={<ChannelManangementPage />} />
            <Route path='channel/create' element={<ChannelCreatePage />} />
            <Route path='channel/:id' element={<ChannelDetailPage />} />
            <Route path='store' element={<StoreManagementPage />} />
            <Route path='media' element={<MediaLibraryListPage />}>
              {/* <Route path='' element={<RedirectionPath path='/media/library' />} />
              <Route path='library' element={<MediaLibraryListPage />} />
              <Route path='link' element={<MediaLinkListPage />} /> */}
            </Route>
            <Route path='media/library/detail' element={<MediaFolderDetailPage />} />
            <Route path='screen/create' element={<ScreenDetailPage />} />
            <Route path='screen/:id' element={<ScreenDetailPage />} />
            <Route path='store/:id' element={<StoreDetailPage />} />
            <Route path='playlist' element={<PlaylistManagementPage />} />
            <Route path='playlist/create' element={<PlaylistCreatePage />} />
            <Route path='playlist/:id' element={<PlaylistDetailPage />} />
          </Route>
        </Route>
        <Route path='/login' element={<LoginPage />} />
        <Route path='/storyboard' element={<StoryboardPage />} />
        <Route path='*' element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
};

export default RootScreens;
